<template>
  <div class="app-container work-log-template-page">
    <el-form ref="queryForm" :model="queryParams" v-show="showSearch" label-width="86px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="模板搜索" prop="keyword">
            <el-input v-model="queryParams.keyword" placeholder="编码/名称/备注" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="状态" prop="status">
            <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width:100%">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['crm:workLogTemplate:save']" type="primary" icon="el-icon-plus" @click="handleAdd">新增模板</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="dataList" height="calc(100vh - 300px)" @row-dblclick="handleEdit">
      <el-table-column label="模板编码" prop="templateCode" min-width="210" fixed="left" show-overflow-tooltip />
      <el-table-column label="模板名称" prop="templateName" min-width="160" fixed="left" show-overflow-tooltip />
      <el-table-column label="默认发送给" prop="defaultReceiverJson" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">{{ userSummary(scope.row.defaultReceiverJson) || '-' }}</template>
      </el-table-column>
      <el-table-column label="上级领导可看" prop="leaderVisibleFlag" width="120" align="center">
        <template slot-scope="scope">{{ Number(scope.row.leaderVisibleFlag) === 1 ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="排序" prop="sortNo" width="80" align="center" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="Number(scope.row.status) === 1"
            active-color="#13ce66"
            inactive-color="#dcdfe6"
            @change="handleStatusChange(scope.row, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updateTime" width="170" align="center" />
      <el-table-column label="操作" width="190" fixed="right" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handlePreview(scope.row)">预览</el-button>
          <el-button v-hasPermi="['crm:workLogTemplate:save']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-hasPermi="['crm:workLogTemplate:remove']" type="text" class="danger" @click="handleRemove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formTitle" :visible.sync="formOpen" width="1080px" append-to-body :close-on-click-modal="false">
      <el-form ref="templateForm" :model="form" :rules="rules" label-width="116px" class="template-form">
        <el-row :gutter="12">
          <el-col :xs="24" :md="12">
            <el-form-item label="模板名称" prop="templateName">
              <el-input v-model="form.templateName" maxlength="120" placeholder="例如 员工日报" @blur="syncTemplateCode" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择状态" style="width:100%">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="排序">
              <el-input-number v-model="form.sortNo" :min="1" :max="999" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="允许改可见人">
              <el-switch v-model="form.allowCustomViewer" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="发送给必填">
              <el-switch v-model="form.receiverRequiredFlag" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="上级领导可看">
              <el-switch v-model="form.leaderVisibleFlag" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="默认发送给">
              <el-select v-model="form.defaultReceiverUserIds" multiple filterable clearable placeholder="请选择默认发送给" style="width:100%">
                <el-option v-for="user in staffOptions" :key="user.userId" :label="user.nickName" :value="user.userId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="field-toolbar">
        <span>内容栏目</span>
        <div>
          <el-button
            v-for="item in quickFieldOptions"
            :key="item.fieldName"
            size="mini"
            plain
            @click="addQuickField(item)"
          >{{ item.fieldName }}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addFieldToEnd">自定义栏目</el-button>
        </div>
      </div>
      <el-table :data="form.fields" border size="mini" class="field-table">
        <el-table-column label="顺序" width="104" align="center">
          <template slot-scope="scope">
            <div class="field-order-actions">
              <el-button
                size="mini"
                icon="el-icon-arrow-up"
                :disabled="scope.$index === 0"
                @click="moveField(scope.$index, -1)"
              />
              <el-button
                size="mini"
                icon="el-icon-arrow-down"
                :disabled="scope.$index === form.fields.length - 1"
                @click="moveField(scope.$index, 1)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="栏目名称" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fieldName" maxlength="80" placeholder="栏目名称" @blur="syncFieldKey(scope.row, scope.$index)" />
          </template>
        </el-table-column>
        <el-table-column label="类型" width="130">
          <template slot-scope="scope">
            <el-select v-model="scope.row.fieldType" style="width:100%">
              <el-option v-for="item in fieldTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="必填" width="70" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.requiredFlag" :active-value="1" :inactive-value="0" />
          </template>
        </el-table-column>
        <el-table-column label="提示文案" min-width="170">
          <template slot-scope="scope">
            <el-input v-model="scope.row.placeholder" maxlength="120" placeholder="提示文案" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="addFieldAfter(scope.$index)">下方添加</el-button>
            <el-button type="text" class="danger" @click="removeField(scope.$index)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="formOpen = false">取消</el-button>
        <el-button icon="el-icon-view" @click="previewCurrentForm">预览效果</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="模板预览" :visible.sync="previewOpen" width="760px" append-to-body>
      <div class="template-preview">
        <div class="preview-title">{{ previewData.templateName || '日志模板' }}</div>
        <div class="preview-meta">
          <span>发送给：{{ userNames(previewData.defaultReceiverUserIds) || '填写时选择' }}</span>
          <span>上级领导：{{ Number(previewData.leaderVisibleFlag) === 1 ? '自动带出' : '不自动带出' }}</span>
        </div>
        <el-form label-width="112px" class="preview-form">
          <el-form-item label="日志日期">
            <el-input disabled placeholder="填写日志时选择日期" />
          </el-form-item>
          <el-form-item
            v-for="field in previewData.fields"
            :key="field.fieldKey || field.fieldName"
            :label="field.fieldName"
            :required="field.requiredFlag === 1"
          >
            <el-input
              v-if="!isUploadField(field)"
              type="textarea"
              :rows="3"
              disabled
              :placeholder="field.placeholder || '请输入'"
            />
            <div v-else-if="field.fieldType === 'image'" class="preview-upload-placeholder image">
              <i class="el-icon-picture-outline"></i>
              <span>填写时上传图片</span>
            </div>
            <div v-else-if="field.fieldType === 'file'" class="preview-upload-placeholder">
              <i class="el-icon-upload"></i>
              <span>填写时上传附件</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  changeWorkLogTemplateStatus,
  getWorkLogTemplateDetail,
  listWorkLogTemplates,
  removeWorkLogTemplate,
  saveWorkLogTemplate
} from '@/api/crm/workLogTemplate'
import { listUserWithOutDataScope } from '@/api/system/user'

const ACTIVE_TENANT_USER_QUERY = { pageNum: 1, pageSize: 999, tenantUserStatus: 1 }

const emptyTemplateForm = () => ({
  id: null,
  templateCode: '',
  templateName: '',
  logType: 'DAILY',
  status: 1,
  sortNo: 100,
  applyScopeType: 'ALL',
  applyUserIds: [],
  allowCustomViewer: 1,
  defaultReceiverUserIds: [],
  receiverRequiredFlag: 1,
  leaderVisibleFlag: 0,
  remark: '',
  fields: []
})

export default {
  name: 'WorkLogTemplate',
  data() {
    return {
      loading: false,
      submitLoading: false,
      showSearch: true,
      formOpen: false,
      previewOpen: false,
      dataList: [],
      staffOptions: [],
      previewData: emptyTemplateForm(),
      queryParams: {
        keyword: '',
        logType: '',
        status: null
      },
      form: emptyTemplateForm(),
      logTypeOptions: [
        { value: 'DAILY', label: '日报' },
        { value: 'WEEKLY', label: '周报' },
        { value: 'CUSTOM', label: '自定义' }
      ],
      statusOptions: [
        { value: 1, label: '启用' },
        { value: 2, label: '停用' }
      ],
      fieldTypeOptions: [
        { value: 'textarea', label: '文本' },
        { value: 'image', label: '图片' },
        { value: 'file', label: '附件' }
      ],
      quickFieldOptions: [
        { fieldName: '今日完成工作', fieldType: 'textarea', requiredFlag: 1, placeholder: '请填写今天完成的主要工作' },
        { fieldName: '明日计划', fieldType: 'textarea', requiredFlag: 1, placeholder: '请填写明日计划' },
        { fieldName: '问题与风险', fieldType: 'textarea', requiredFlag: 0, placeholder: '请填写遇到的问题、风险或阻塞' },
        { fieldName: '需要协助', fieldType: 'textarea', requiredFlag: 0, placeholder: '请填写需要协助的事项' },
        { fieldName: '相关图片', fieldType: 'image', requiredFlag: 0, placeholder: '' },
        { fieldName: '相关附件', fieldType: 'file', requiredFlag: 0, placeholder: '' }
      ],
      rules: {
        templateName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formTitle() {
      return this.form.id ? '编辑日志模板' : '新增日志模板'
    }
  },
  created() {
    this.loadUsers()
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      listWorkLogTemplates(this.cleanParams(this.queryParams))
        .then(response => {
          this.dataList = (response && response.data) || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadUsers() {
      listUserWithOutDataScope(ACTIVE_TENANT_USER_QUERY).then(response => {
        this.staffOptions = (response && response.rows) || []
      })
    },
    handleQuery() {
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        keyword: '',
        logType: '',
        status: null
      }
      this.getList()
    },
    handleAdd() {
      this.form = emptyTemplateForm()
      this.form.fields = [
        this.newField('today_work', '今日工作', 10),
        this.newField('tomorrow_plan', '明日计划', 20),
        this.newField('need_help', '需协调事项', 30)
      ]
      this.formOpen = true
      this.$nextTick(() => this.clearValidate())
    },
    handleEdit(row) {
      if (!row || !row.id) {
        return
      }
      getWorkLogTemplateDetail(row.id).then(response => {
        const detail = (response && response.data) || {}
        this.form = {
          ...emptyTemplateForm(),
          ...detail,
          applyUserIds: this.parseIds(detail.applyScopeJson),
          defaultReceiverUserIds: this.parseIds(detail.defaultReceiverJson),
          fields: ((detail.fields || []).filter(item => Number(item.delFlag || 0) !== 1)).map(item => ({
            id: item.id,
            fieldKey: item.fieldKey || '',
            fieldName: item.fieldName || '',
            fieldType: item.fieldType || 'textarea',
            requiredFlag: Number(item.requiredFlag) === 1 ? 1 : 0,
            placeholder: item.placeholder || '',
            optionsJson: item.optionsJson || '',
            optionText: this.optionsJsonToText(item.optionsJson),
            defaultValue: item.defaultValue || '',
            maxLength: item.maxLength || 1000,
            sortNo: item.sortNo || 100,
            status: Number(item.status) === 2 ? 2 : 1
          }))
        }
        this.formOpen = true
        this.$nextTick(() => this.clearValidate())
      })
    },
    submitForm() {
      this.$refs.templateForm.validate(valid => {
        if (!valid || !this.validateFields()) {
          return
        }
        this.submitLoading = true
        saveWorkLogTemplate(this.buildPayload())
          .then(() => {
            this.$message.success('保存成功')
            this.formOpen = false
            this.getList()
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    buildPayload() {
      this.prepareFields()
      this.syncTemplateCode()
      return {
        id: this.form.id,
        templateCode: this.form.templateCode,
        templateName: this.form.templateName,
        logType: 'DAILY',
        status: this.form.status,
        sortNo: this.form.sortNo,
        applyScopeType: 'ALL',
        applyScopeJson: '',
        allowCustomViewer: this.form.allowCustomViewer,
        defaultReceiverJson: JSON.stringify(this.form.defaultReceiverUserIds || []),
        defaultCcJson: '[]',
        receiverRequiredFlag: this.form.receiverRequiredFlag,
        leaderVisibleFlag: this.form.leaderVisibleFlag,
        remark: this.form.remark,
        fields: this.form.fields.map(item => ({
          id: item.id,
          fieldKey: item.fieldKey,
          fieldName: item.fieldName,
          fieldType: item.fieldType,
          requiredFlag: item.requiredFlag,
          placeholder: item.placeholder,
          optionsJson: '',
          defaultValue: item.defaultValue,
          maxLength: item.maxLength,
          sortNo: item.sortNo,
          status: item.status
        }))
      }
    },
    syncTemplateCode() {
      if (!this.form.templateCode) {
        this.form.templateCode = this.autoTemplateCode(this.form.templateName)
      }
    },
    autoTemplateCode(templateName) {
      const base = this.autoFieldKey(templateName || 'work_log', 0).toUpperCase()
      const suffix = Date.now().toString(36).slice(-5).toUpperCase()
      return `TPL_${base || 'WORK_LOG'}_${suffix}`
    },
    validateFields() {
      if (!this.form.fields || !this.form.fields.length) {
        this.$message.warning('请至少添加一个内容栏目')
        return false
      }
      const keys = new Set()
      for (const field of this.form.fields) {
        if (!field.fieldName || !field.fieldName.trim()) {
          this.$message.warning('栏目名称不能为空')
          return false
        }
        if (keys.has(field.fieldKey)) {
          this.$message.warning(`栏目编码重复：${field.fieldKey}`)
          return false
        }
        keys.add(field.fieldKey)
      }
      return true
    },
    addFieldToEnd() {
      this.addFieldAfter((this.form.fields || []).length - 1)
    },
    addFieldAfter(index) {
      const fields = this.form.fields || []
      const insertIndex = Math.max(0, Math.min(Number(index) + 1, fields.length))
      const fieldNo = fields.length + 1
      fields.splice(insertIndex, 0, this.newField(`field_${fieldNo}`, '新栏目', (insertIndex + 1) * 10))
      this.form.fields = fields
      this.renumberFields()
    },
    addQuickField(item) {
      const index = (this.form.fields || []).length + 1
      this.form.fields.push({
        ...this.newField('', item.fieldName, index * 10),
        fieldType: item.fieldType,
        requiredFlag: item.requiredFlag,
        placeholder: item.placeholder
      })
      this.prepareFields()
    },
    newField(fieldKey, fieldName, sortNo) {
      return {
        fieldKey,
        fieldName,
        fieldType: 'textarea',
        requiredFlag: 1,
        placeholder: '',
        optionsJson: '',
        defaultValue: '',
        maxLength: 1000,
        sortNo,
        status: 1
      }
    },
    prepareFields() {
      const used = new Set()
      this.form.fields.forEach((field, index) => {
        if (!field.fieldKey || !field.fieldKey.trim()) {
          field.fieldKey = this.autoFieldKey(field.fieldName, index)
        }
        while (used.has(field.fieldKey)) {
          field.fieldKey = `${field.fieldKey}_${index + 1}`
        }
        used.add(field.fieldKey)
      })
      this.renumberFields()
    },
    renumberFields() {
      (this.form.fields || []).forEach((field, index) => {
        field.sortNo = (index + 1) * 10
      })
    },
    moveField(index, direction) {
      const fields = this.form.fields || []
      const targetIndex = index + direction
      if (targetIndex < 0 || targetIndex >= fields.length) {
        return
      }
      const moved = fields.splice(index, 1)[0]
      fields.splice(targetIndex, 0, moved)
      this.form.fields = fields
      this.renumberFields()
    },
    autoFieldKey(fieldName, index) {
      const name = String(fieldName || '').trim()
      if (!name) {
        return `field_${index + 1}`
      }
      const map = [
        ['今日', 'today'],
        ['明日', 'tomorrow'],
        ['计划', 'plan'],
        ['工作', 'work'],
        ['完成', 'done'],
        ['问题', 'problem'],
        ['风险', 'risk'],
        ['协助', 'support'],
        ['图片', 'image'],
        ['照片', 'photo'],
        ['附件', 'attachment'],
        ['文件', 'file'],
        ['内容', 'content'],
        ['学习', 'learning'],
        ['员工', 'employee'],
        ['实习', 'intern'],
        ['日报', 'daily'],
        ['周报', 'weekly'],
        ['日志', 'log'],
        ['模板', 'template'],
        ['导师', 'mentor'],
        ['本周', 'week'],
        ['下周', 'next_week'],
        ['客户', 'customer'],
        ['项目', 'project']
      ]
      let key = name
      map.forEach(item => {
        key = key.replace(new RegExp(item[0], 'g'), `_${item[1]}_`)
      })
      key = key
        .replace(/[^\w]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .toLowerCase()
      return key || `field_${index + 1}`
    },
    syncFieldKey(row, index) {
      if (!row.fieldKey || /^field_\d+$/.test(row.fieldKey)) {
        row.fieldKey = this.autoFieldKey(row.fieldName, index)
      }
    },
    removeField(index) {
      this.form.fields.splice(index, 1)
    },
    previewCurrentForm() {
      this.prepareFields()
      this.previewData = JSON.parse(JSON.stringify(this.form))
      this.previewOpen = true
    },
    handlePreview(row) {
      if (!row || !row.id) {
        return
      }
      getWorkLogTemplateDetail(row.id).then(response => {
        const detail = (response && response.data) || {}
        this.previewData = {
          ...emptyTemplateForm(),
          ...detail,
          defaultReceiverUserIds: this.parseIds(detail.defaultReceiverJson),
          fields: ((detail.fields || []).filter(item => Number(item.delFlag || 0) !== 1 && Number(item.status || 1) === 1)).map(item => ({
            fieldKey: item.fieldKey,
            fieldName: item.fieldName,
            fieldType: this.isUploadField(item) ? item.fieldType : 'textarea',
            requiredFlag: Number(item.requiredFlag) === 1 ? 1 : 0,
            placeholder: item.placeholder || ''
          }))
        }
        this.previewOpen = true
      })
    },
    userNames(ids) {
      if (!ids || !ids.length) {
        return ''
      }
      const nameMap = {}
      this.staffOptions.forEach(user => {
        nameMap[user.userId] = user.nickName
      })
      return ids.map(id => nameMap[id] || id).join('、')
    },
    optionsJsonToText(text) {
      if (!text) {
        return ''
      }
      try {
        const parsed = JSON.parse(text)
        return Array.isArray(parsed) ? parsed.map(item => typeof item === 'object' ? (item.label || item.name || item.value || '') : item).filter(Boolean).join('\n') : ''
      } catch (e) {
        return ''
      }
    },
    handleStatusChange(row, enabled) {
      const nextStatus = enabled ? 1 : 2
      changeWorkLogTemplateStatus(row.id, nextStatus)
        .then(() => {
          this.$message.success('状态已更新')
          this.getList()
        })
        .catch(() => {
          this.getList()
        })
    },
    handleRemove(row) {
      this.$confirm(`确认删除日志模板「${row.templateName || row.templateCode}」？`, '提示', { type: 'warning' })
        .then(() => removeWorkLogTemplate(row.id))
        .then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
        .catch(error => {
          if (error !== 'cancel' && error !== 'close') {
            this.getList()
          }
        })
    },
    clearValidate() {
      if (this.$refs.templateForm) {
        this.$refs.templateForm.clearValidate()
      }
    },
    parseIds(text) {
      if (!text) {
        return []
      }
      try {
        const parsed = JSON.parse(text)
        if (!Array.isArray(parsed)) {
          return []
        }
        return parsed.map(item => Number(item)).filter(item => !Number.isNaN(item))
      } catch (e) {
        return []
      }
    },
    userSummary(text) {
      const ids = this.parseIds(text)
      if (!ids.length) {
        return ''
      }
      const nameMap = {}
      this.staffOptions.forEach(user => {
        nameMap[user.userId] = user.nickName
      })
      return ids.map(id => nameMap[id] || id).join('、')
    },
    logTypeText(value) {
      const item = this.logTypeOptions.find(option => option.value === value)
      return item ? item.label : (value || '-')
    },
    isUploadField(field) {
      return field && (field.fieldType === 'file' || field.fieldType === 'image')
    },
    cleanParams(params) {
      const result = {}
      Object.keys(params || {}).forEach(key => {
        const value = params[key]
        if (value !== '' && value !== null && value !== undefined) {
          result[key] = value
        }
      })
      return result
    }
  }
}
</script>

<style scoped>
.work-log-template-page {
  background: #fff;
}

.template-form {
  padding-right: 8px;
}

.field-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0 10px;
  font-weight: 600;
  color: #303133;
}

.field-table {
  margin-bottom: 10px;
}

.field-order-actions {
  display: inline-flex;
  align-items: center;
}

.field-order-actions .el-button + .el-button {
  margin-left: 4px;
}

.template-preview {
  padding: 2px 4px 8px;
}

.preview-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
}

.preview-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0 18px;
  color: #606266;
}

.preview-upload-placeholder {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border: 1px dashed #c0c4cc;
  border-radius: 4px;
  color: #909399;
  background: #fafafa;
}

.preview-upload-placeholder.image {
  color: #2f80ed;
  border-color: #b9d6ff;
  background: #f4f8ff;
}

.danger {
  color: #f56c6c;
}
</style>
